import cn from 'classnames';
import React, { FC } from 'react';
import { handleFreeReturn } from '@lambda/commons/helpers';
import { getShortenCountryName } from '@/lib/use-origin-country';
import settings from '@/settings';

const freeReturnDays = handleFreeReturn(
  settings.store,
  settings.free_return_days,
);

// DEPRECATED - use the ParseMarkdown component in /components/markdown instead
// leaving this here to limit the scope of changes in RT-5161 - tyler 2023-09-19
const parseMarkdown = (markdown: string, variables: Record<string, string>) => {
  const lines = markdown.split('\n');

  return lines.map((line, index) => {
    if (line.startsWith('#')) {
      const match = line.match(/^#+/);
      const headerLevel = match ? match[0].length : 0;
      const text = line.substring(headerLevel).trim();
      const headerClass = cn({
        'font-semibold text-lg xs:text-xl text-gray-700 pt-5':
          headerLevel === 1,
        'font-semibold text-sm xs:text-base mt-5': headerLevel === 2,
      });

      return React.createElement(
        `h${headerLevel + 1}`,
        { key: index, className: headerClass },
        text,
      );
    }
    let result = line
      .replace(
        /\[(.*?)\]\((.*?)\)/g,
        (match, linkText, linkHref) =>
          `<a className="underline" target="_blank" href="${
            linkText === 'Reebelo' ? window.location.origin : linkHref
          }">${linkText}</a>`,
      )
      .replace(/\b12 months?\b/g, (match) => {
        // Replace any 12 month(s) with up to 12 month(s) foor US/SG
        if (['reebelo-us', 'quista'].includes(settings.store))
          return `up to ${match}`;

        return match;
      })
      .replace(/\b(30|14) days\b/g, () => `${freeReturnDays} days`); // Replace 30/14 days with its actual corresponding data per store

    Object.entries(variables).forEach(([key, value]) => {
      result = result.replace(new RegExp(`{{${key}}}`, 'g'), value);
    });

    return (
      <div
        className="text-sm"
        key={index}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: result }}
      />
    );
  });
};

const Description: FC<{ description: string }> = ({ description }) => {
  const variables = {
    country: getShortenCountryName(),
    free_return_days: `${freeReturnDays}`,
    warranty_month: ['reebelo-us', 'quista'].includes(settings.store)
      ? `up to ${settings.warranty_month}`
      : `${settings.warranty_month}`,
  };

  return <div>{parseMarkdown(description, variables)}</div>;
};

export default Description;
